module.exports = __webpack_public_path__ + "static/media/book5.2b08c31a.jpg";